import React, { useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import PaymentHistory from "./index_view/PaymentsHistory";
import SubsForm from "./index_view/SubsForm";
import SubPaymentApprove from "./index_view/SubPaymentApprove";
import SmsForm from "./index_view/SmsForm";
import { StateContext } from "./State";

const IndexView = (props) => {
  const [state, setState] = useState({
    ...props,
    sum: 0,
    paid_period: 0,
    selected_plan: { name: "", highest_price_special: 0, lowest_price_special: 0 },
  });

  const updateState = (newState) => {
    setState((state) => ({ ...state, ...newState }));
  };

  return (
    <StateContext.Provider value={{ state, updateState }}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<PaymentHistory />} />
          <Route path="/new" element={<SubsForm />} />
          <Route path="/new/approve" element={<SubPaymentApprove />} />
          <Route path="/sms/new" element={<SmsForm />} />
        </Routes>
      </HashRouter>
    </StateContext.Provider>
  );
};

export default IndexView;
